module.exports = __webpack_public_path__ + "static/media/14_before.403f82f7.jpg";